var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showBack)?_c('v-btn',{staticClass:"white--text app-btn",attrs:{"depressed":"","tile":"","color":"grey"},on:{"click":function($event){$event.stopPropagation();return _vm.$router.back()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }